module.exports = __webpack_public_path__ + "static/media/secconn.fd5275bd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/secconn.png
 ** module id = 1622
 ** module chunks = 0
 **/